/* global femcare, Swiper */

femcare.gallery.image = {
    init() {
        const galleries = document.querySelectorAll('.image-gallery');

        if (galleries.length) {
            galleries.forEach(gallery => {
                const galleryContent = gallery.querySelector('.image-gallery__content');

                const swiper = new Swiper(galleryContent, {
                    breakpoints: {
                        320: {
                            spaceBetween: 15,
                            slidesPerView: 1.25
                        },
                        992: {
                            spaceBetween: 30,
                            slidesPerView: 1.17
                        }
                    },
                    centeredSlides: true,
                    navigation: {
                        nextEl: galleryContent.querySelector('.image-gallery__arrow--next'),
                        prevEl: galleryContent.querySelector('.image-gallery__arrow--previous')
                    }
                });

                // Slide change handler
                swiper.on('transitionEnd', () => {
                    this.onTranslated(swiper, galleryContent);
                });

                // Page indicator click handler
                const pages = gallery.querySelectorAll('.image-gallery__page');
                pages.forEach((page, index) => {
                    page.addEventListener('click', () => {
                        swiper.slideTo(index, 600);
                    });
                });
            });
        }
    },

    onTranslated(swiper, galleryContent) {
        const gallery = galleryContent.closest('.image-gallery');
        const pagination = gallery?.querySelector('.image-gallery__pagination');
        if (!pagination) return;

        const pages = pagination.querySelectorAll('.image-gallery__page');
        const activeClass = 'image-gallery__page--active';
        const srIndicator = pagination.querySelector('.image-gallery__sr-active-indicator');

        // Clear previous active
        pages.forEach(page => page.classList.remove(activeClass));

        // Set new active and re-append screen reader indicator
        const activePage = pages[swiper.activeIndex];
        if (activePage) {
            activePage.classList.add(activeClass);
            if (srIndicator) {
                activePage.appendChild(srIndicator);
            }
        }
    }
};
